export const generateProjectionHash = (proj: d3.GeoProjection): string =>
  `${proj.scale()}|${proj.rotate().join(',')}`;
